function alThemeString(key, fallback) {
  return window.theme && theme.strings && theme.strings[key] ? theme.strings[key] : fallback;
}

function alThemeTemplate(key, fallback, replacements) {
  var value = alThemeString(key, fallback);
  Object.keys(replacements || {}).forEach(function (name) {
    value = value.split('[' + name + ']').join(replacements[name]);
  });
  return value;
}

var $window = $(window);
// Sticky atc section
if($('.product-sticky-atc-grid').length > 0){
  var $container = $(".product-sticky-atc-grid"); 
  var $containerHeight = $container.innerHeight();   
  var $containerOffsetTop = $(".product-section").offset().top; 
  var $hiddencontainerheight = $(".product-section").innerHeight();
  var $containerOffset = $container.offset();
  var $finalOffsetTop = $hiddencontainerheight - $containerOffsetTop - 100;
  
  $window.scroll(function(){
      if($window.scrollTop() > $finalOffsetTop){
          $container.addClass("sticky-atc-active");   
      }else{
          $container.removeClass("sticky-atc-active");   
      }    
      if($window.scrollTop() + $containerHeight > $finalOffsetTop) {
        $container.css({"bottom": "0",});       
      } else{
        $container.css({"bottom": "0",});  
      }    
  });  
}


jQuery(document).ready(function($){
  // Product form on variation change
  $('.product-block .variant-wrapper.js .variant-input-wrap .variant-input input[type="radio"]').on('change', function(){
   if($(this).closest('.variant-wrapper').hasClass('variant-color')){
     var value = $(this).val();
     var variant_image = $('.product__main-photos .product-main-slide.is-selected image-element img').attr('src');
     if(variant_image != '' && variant_image != 'undefined' && variant_image != null){
       $('.product-sticky-atc-grid form#sticky-atc-form .sticky-atc__product img').attr('src',variant_image);
     }
   }
   
   var selected_value = ''; var selected_vprice = 0;
   var numItems = $('.product-block .variant-wrapper.js').length;

   var count = 1; 
   $('.product-block .variant-wrapper.js').each(function(){
     if(parseInt(count) < parseInt(numItems)){
       selected_value += $(this).find('.variant-input-wrap .variant-input input[type="radio"]:checked').val()+' / ';
     }else{
       selected_value += $(this).find('.variant-input-wrap .variant-input input[type="radio"]:checked').val();
     }
     count++;
   }) 

   if(selected_value != ''){
     $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option').each(function(){ 
        if($(this).attr('data-match') == selected_value){
         $(this).attr('selected',true); 
         if($(this).attr('disabled') == 'disabled'){
           $('.product-sticky-atc-grid .atc-btn-grid button').attr('disabled',true);
           $('.product-sticky-atc-grid .atc-btn-grid button').text(alThemeString('soldOut', 'Ausverkauft'));
         }else{
           $('.product-sticky-atc-grid .atc-btn-grid button').removeAttr('disabled');
           $('.product-sticky-atc-grid .atc-btn-grid button').text(alThemeString('addToCart', 'In den Warenkorb')); 
         } 
        }else{
          $(this).removeAttr('selected');
        }
     })


    $('#check-for-availability option').each(function(){
      if($(this).attr('data-match') == selected_value){
        if($(this).attr('disabled') == 'disabled'){
          if($(this).closest('.product-block.product-block--sales-point').hasClass('hide')){
            $(this).closest('.product-block.product-block--sales-point').removeClass('hide');
          }
          if($(this).closest('.product-block.product-block--sales-point').find('.sales-point2').hasClass('hide')){
            $(this).closest('.product-block.product-block--sales-point').find('.sales-point2').removeClass('hide');
            $(this).closest('.product-block.product-block--sales-point').find('.sales-point').addClass('hide');
          }
          var message = $(this).attr('data-message');
          console.log(message);
          $('ul.sales-points li.sales-point2 span.pre-order-text').text(message);
        }else{
         $(this).closest('.product-block.product-block--sales-point').find('.sales-point2').addClass('hide');
         $(this).closest('.product-block.product-block--sales-point').find('.sales-point').removeClass('hide');
        }
      }
    });


    var vid = $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option:selected').val();
     
    var $selectedStickyOption = $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option:selected');
    selected_vprice = $selectedStickyOption.attr('data-price-nozero');
    if(typeof selected_vprice != 'undefined'){
      var $priceBlock = $(this).closest('.product-single__meta').find('.product-block--price');
      var $price = $priceBlock.find('span[data-product-price]');
      var alSaleVisualEnabled = $price.attr('data-al-sale-visual') === 'true';
      var alSaleDiscountPercent = parseFloat($price.attr('data-al-sale-discount-percent') || '0');
      var priceCents = parseInt($selectedStickyOption.attr('data-price-cents') || '0', 10);
      var compareAtCents = parseInt($selectedStickyOption.attr('data-compare-at-cents') || '0', 10);
      var canShowThemeSale = alSaleVisualEnabled &&
        alSaleDiscountPercent > 0 &&
        alSaleDiscountPercent < 100 &&
        priceCents > 0 &&
        compareAtCents <= priceCents;

      if (canShowThemeSale && window.theme && theme.Currency && theme.settings) {
        var salePriceCents = Math.round(priceCents * (100 - alSaleDiscountPercent) / 100);
        var alPriceFormatter = $(this).closest('[data-al-pdp-standard]').length ? theme.Currency.formatMoneyWithoutTrailingZeros : theme.Currency.formatMoney;
        $price.text(alPriceFormatter(salePriceCents, theme.settings.moneyFormat));
        $price.addClass('on-sale');
        $priceBlock.find('[data-compare-price]').text(alPriceFormatter(priceCents, theme.settings.moneyFormat));
        $priceBlock.find('[data-product-price-wrap]').removeClass('hide');
        $priceBlock.find('[data-al-pdp-sale-badge]').removeClass('hide');
        $priceBlock.find('[data-save-price]').addClass('hide');
      } else {
        $price.text(selected_vprice);
        if (alSaleVisualEnabled && compareAtCents <= priceCents) {
          $price.removeClass('on-sale');
          $priceBlock.find('[data-product-price-wrap]').addClass('hide');
          $priceBlock.find('[data-al-pdp-sale-badge]').addClass('hide');
          $priceBlock.find('[data-save-price]').addClass('hide');
        }
      }
    }

    if(vid != '' && vid != 'undefined' && vid != null){
      $('form#addon-form .addon-product-grid.variation-addons .addon-row').each(function(){
        if($(this).attr('data-vid') == vid){
          $(this).show();
        }else{
          $(this).hide();
        }
      })
    }
     
   }  
    
  })


  // Sticky atc on variant change
  $('.product-sticky-atc-grid .sticky-product-variant select').on('change',function(){
    var selected_value = $(this).find('option:selected').attr('data-match');
    if($(this).find('option:selected').is(":disabled")){
      $('.product-sticky-atc-grid .atc-btn-grid button').attr('disabled',true);
      $('.product-sticky-atc-grid .atc-btn-grid button').text(alThemeString('soldOut', 'Ausverkauft'));
    }else{
      $('.product-sticky-atc-grid .atc-btn-grid button').removeAttr('disabled');
      $('.product-sticky-atc-grid .atc-btn-grid button').text(alThemeString('addToCart', 'In den Warenkorb')); 
    }
    var selected_vid = $(this).val(); 
    var selected_value_arr = [];
    if(selected_value != '' && selected_value != 'undefined' && selected_value != null){
       selected_value_arr = selected_value.split(" / ");
    }
    if(selected_value_arr != '' && selected_value_arr != 'undefined' && selected_value_arr != null){
      $('.product-block .variant-wrapper.js .variant-input').each(function(){
        if(selected_value_arr.includes($(this).attr('data-value'))){
            $(this).find('input[type="radio"]').prop('checked',true);
            $('.product-block .variant-wrapper.js .variant-input input[type="radio"]').removeAttr('checked');
        }		
      })

      $('.product-block .variant-wrapper.js.variant-color .variant-input').each(function(){
        var selected_color = $(this).find('input[type="radio"]:checked').val();
        if(selected_color != '' && selected_color != 'undefined' && selected_color != null){
          $(this).closest('.variant-color').find('.variant__label span[data-variant-color-label]').text(selected_color);
        }
      })
    }

    if(selected_vid != '' && selected_vid != 'undefined' && selected_vid != null){
      $('.product-single__variants option').each(function(){
        if($(this).val() == selected_vid){
          $(this).attr('selected',true);
          $(this).closest('.product-single__variants').trigger('change');
        }else{
          $(this).removeAttr('selected');
        }
      })
    }
  })

  // Sticky atc on quanity increases
  $('.product-sticky-atc-grid .sticky-quantity-wrap button.btn.sticky-btn-plus').on('click',function(){
   var old_qty = $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val();
   var new_qty = 0;
   if(old_qty != '' && old_qty != 'undefined' && old_qty != null){
     new_qty = parseInt(old_qty)+parseInt(1);
   }
   if(new_qty != '' && new_qty != 'undefined' && new_qty != null){
     $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val(new_qty);
   }
  }) 

  // Sticky atc on quanity decreases
  $('.product-sticky-atc-grid .sticky-quantity-wrap button.btn.sticky-btn-minus').on('click',function(){
   var old_qty = $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val();
   var new_qty = 0;
   if(old_qty > 1){
     new_qty = parseInt(old_qty)-parseInt(1);
     if(new_qty != '' && new_qty != 'undefined' && new_qty != null){
       $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val(new_qty);
     }
   }
  })  

  // Sticky add to cart on atc button clicked
  $(document).on('click','.product-sticky-atc-grid.sticky-atc-active .atc-btn-grid button',function(e){
    e.preventDefault();
    var variant_id = $(this).closest('.product-sticky-atc-grid').find('#sticky-atc-form select[name="sticky-variant"]').val();
    var qty = $(this).closest('.product-sticky-atc-grid').find('.sticky-quantity-wrap #sticky-qty').val();
    var data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: theme.routes.cartAdd,
      data: data,
      dataType: 'json',
      success: function(product){ 
        var cart = new theme.CartDrawer
          cart.init()
          cart.open();
      },
      error: function(response){
        if(response.status == 400){
          alert('Error on adding product to cart. Please try again after sometime.');
        }
      }
    }); 
  })


  /************** Cart tooltip ****************/
  $('.custom-delivery-checkbox .cart-attribute__field span.cart-checkbox-tooltip').on('mouseover',function(){
    $(this).find('.tooltiptext').addClass('show');
  })  

  $('.custom-delivery-checkbox .cart-attribute__field span.cart-checkbox-tooltip').on('mouseout',function(){
    $(this).find('.tooltiptext').removeClass('show');
  })  

  /********************************************/

  // Product form button atc on clicked
  $('.product-block .product-single__form button[data-add-to-cart]').on('click',function(e){
    setTimeout(function(){
      var check_preorder = 0;
      if($('div#CartDrawer').length > 0){
        $('#CartDrawer form#CartDrawerForm .cart__items .cart__item').each(function(){
          if($(this).attr('data-item-type') == 'preorder'){
            check_preorder = 1
          }
        })

        if(check_preorder == 1){
          $('#CartDrawer').find('.custom-delivery-checkbox').addClass('show');
        }
      }
    }, 1000);
  })


  /************************ Product Addons Script ***********************/
  $('form#addon-form #addon-product-grid .addon-row .acol-6 .item-detail span.item-atc input.custom_addon_checkbox').on('click', function(){
    var variant_id = $(this).val();
    if($(this).is(':checked')){
      var qty = 1;
      var data = {
        "id": variant_id,
        "quantity": qty
      }
      jQuery.ajax({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json',
        beforeSend: function(){
          $('#addon-product-grid').addClass('fadeop');
        },
        success: function(product){ 
          $('#addon-product-grid').removeClass('fadeop');
          setTimeout(function(){
            var cart = new theme.CartDrawer
            cart.init()
            cart.open();
          }, 1000);
        },
        error: function(response){
          $('#addon-product-grid').removeClass('fadeop');
          setTimeout(function(){
            if(response.status == 400){
              alert('Error on adding product to cart. Please try again after sometime.');
            }
          }, 1000);
        }
      }); 
    }else{
      var remove_item_id = '';
      $.getJSON(theme.routes.cart, function(cart) {
        var cart_item = cart.items;
        for(var i=0;i<cart_item.length;i++){
          if(cart_item[i].id == variant_id){
            remove_item_id = cart_item[i].id;
            $.ajax({
              type: "POST",
              url: theme.routes.cartChange,
              dataType: "json",
              beforeSend: function(){
                $('#addon-product-grid').addClass('fadeop');
              },
              data: {
                id: remove_item_id,
                quantity: 0,
              },
            }).then((data) => {
              $('#addon-product-grid').removeClass('fadeop');
              setTimeout(function(){
                var cart = new theme.CartDrawer
                cart.init()
                cart.open();
              }, 1000);
            });
          }
        }
      });
    }
  })

  /*********************** Product Addons Script End ********************/

  
})


/*****************Free Shipping Progress********************/ 

function updateFreeShipping(cart) {
  const shippingPrice = 400; // CHF 4.00 in cents
  const shippingStatus = document.getElementById('shipping-status');
  const integratedProgress = document.querySelector('[data-alunir-sale-gift-progress]');
  const configuredThreshold = shippingStatus && shippingStatus.dataset.freeShippingThreshold
    ? shippingStatus.dataset.freeShippingThreshold
    : integratedProgress && integratedProgress.dataset.freeShippingThreshold;
  const threshold = Number(configuredThreshold) || 7000;
  const current = cart.total_price;
  const remaining = threshold - current;

  const msgEl = document.querySelector('.free-shipping-progress .progress-msg');
  const fillEl = document.querySelector('.free-shipping-progress .progress-fill');
  const formatMoney = function(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return 'CHF ' + (cents / 100).toFixed(2);
  };

  if (current >= threshold) {
    if (shippingStatus) {
      shippingStatus.textContent = shippingStatus.dataset.freeLabel || 'Gratis';
      shippingStatus.classList.add('is-free');
    }
  } else if (shippingStatus) {
    shippingStatus.textContent = formatMoney(parseInt(shippingStatus.dataset.shippingPrice, 10) || shippingPrice);
    shippingStatus.classList.remove('is-free');
  }

  if (!msgEl || !fillEl) return;

  if (current >= threshold) {
    msgEl.innerHTML = alThemeString('alunirFreeShippingUnlockedHtml', '\u{1F389} Gl\u00FCckwunsch! Du hast <strong>kostenlosen Versand!</strong>');
    if (shippingStatus) {
      shippingStatus.textContent = shippingStatus.dataset.freeLabel || 'Gratis';
      shippingStatus.classList.add('is-free');
    }
  } else {
    msgEl.innerHTML = alThemeTemplate('alunirFreeShippingRemainingHtml', '\u{1F69A} Noch <strong>[amount]</strong> f\u00FCr kostenlosen Versand!', { amount: formatMoney(remaining) });
    if (shippingStatus) {
      shippingStatus.textContent = formatMoney(parseInt(shippingStatus.dataset.shippingPrice, 10) || shippingPrice);
      shippingStatus.classList.remove('is-free');
    }
  }

  let percent = Math.min(100, (current / threshold) * 100);
  fillEl.style.width = percent + '%';

}

function refreshFreeShipping() {
  fetch(theme.routes.cart)
    .then(res => res.json())
    .then(cart => updateFreeShipping(cart));
}


document.addEventListener('ajaxProduct:added', function(event) {
    refreshFreeShipping();
});


// Always run on cart updates too
document.addEventListener('cart:updated', refreshFreeShipping);

document.addEventListener('cart:drawer:open', refreshFreeShipping);



// product page tooltip 24/06/25
$(document).ready(function(){
$('.mor-info-badge').click(function(){
 $(this).parent().find('.productimg-tooltipdesc').fadeToggle(500); 
}); 
});

  

/* EU verhindern über 150 Eur und Meldung */

/* EU verhindern über 150 Eur und Meldung */
(function () {
  var EU = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"];
  var LIMIT = 15000; // 150 EUR in cents

function setCheckoutDisabled(disabled, notice) {
  var btn = document.querySelector('#CartDrawer button[name="checkout"]');
  if (!btn) return;

  // Originaltext einmalig merken
  if (!btn.dataset.originalText) {
    btn.dataset.originalText = btn.textContent.trim();
  }

  if (disabled) {
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('is-disabled-eu');
    var splitLabel = notice.querySelector('[data-eu-split-label]');
    btn.textContent = splitLabel ? splitLabel.textContent.trim() : btn.dataset.originalText;
  } else {
    btn.removeAttribute('disabled');
    btn.classList.remove('is-disabled-eu');
    btn.textContent = notice.dataset.checkoutLabel || btn.dataset.originalText;
  }
}

  function updateEUNotice() {
    var notice = document.getElementById('eu150Notice');
    if (!notice) return;

    var country = notice.getAttribute('data-country') || (window.Shopify && Shopify.country) || '';
    country = (country || '').toUpperCase();
    var isEU = EU.indexOf(country) !== -1;

    fetch(theme.routes.cart)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
  var isEUActive = isEU;

  // Hinweis (falls du ihn weiterhin nutzen willst)
  notice.style.display = (isEU && cart.total_price > LIMIT) ? 'block' : 'none';
  setCheckoutDisabled(isEU && cart.total_price > LIMIT, notice);

  // Availability-Text: EU -> Lieferzeit, sonst Standard
  var availability = document.querySelector('#CartDrawer .text-instock-availability');
  if (availability) {
    if (!availability.dataset.defaultText) {
      availability.dataset.defaultText = availability.textContent.trim();
    }

    if (isEUActive) {
      availability.textContent = notice.dataset.euDeliveryLabel || availability.dataset.defaultText;
    } else {
      availability.textContent = availability.dataset.defaultText;
    }
  }
});
  }

  document.addEventListener('DOMContentLoaded', updateEUNotice);
  document.addEventListener('cart:updated', updateEUNotice);
  document.addEventListener('cart:refresh', updateEUNotice);
  document.addEventListener('cart:drawer:open', updateEUNotice);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-drawer-open-cart')) {
      setTimeout(updateEUNotice, 100);
    }
  });
})();

/* Alunir variant badge panels */
(function () {
  if (window.alunirProductBadgesReady) return;
  window.alunirProductBadgesReady = true;

  function updateBadgePanels(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-al-product-badges]').forEach(function (badgeStack) {
      var panels = badgeStack.querySelectorAll('[data-al-badge-variant]');
      var hasActivePanel = false;

      if (!panels.length) return;

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-al-badge-variant') === String(variantId);
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          hasActivePanel = true;
        }
      });

      badgeStack.classList.toggle('is-empty', !hasActivePanel);
    });
  }

  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    updateBadgePanels(event.detail.variant.id);
  });
})();

/* Alunir sale gift selector */
(function () {
  if (window.alunirSaleGiftReady) return;
  window.alunirSaleGiftReady = true;

  var isSyncingGift = false;

  function getGiftModule(element) {
    if (element && element.closest) {
      return element.closest('[data-alunir-sale-gift]');
    }
    return document.querySelector('[data-alunir-sale-gift]');
  }

  function getGiftConfig(module) {
    module = module || getGiftModule();
    if (!module) return null;

    var threshold = Number(module.getAttribute('data-threshold'));
    var giftIds = Array.prototype.slice.call(module.querySelectorAll('[data-alunir-sale-gift-select]'))
      .map(function (button) {
        return Number(button.getAttribute('data-alunir-sale-gift-select'));
      })
      .filter(function (variantId, index, ids) {
        return variantId && ids.indexOf(variantId) === index;
      });
    var configuredGiftIds = (module.getAttribute('data-gift-variant-ids') || '')
      .split(',')
      .map(function (variantId) {
        return Number(variantId);
      })
      .filter(Boolean);
    var productGiftIds = (module.getAttribute('data-gift-product-variant-ids') || '')
      .split(',')
      .map(function (variantId) {
        return Number(variantId);
      })
      .filter(Boolean);

    giftIds = giftIds.concat(configuredGiftIds).filter(function (variantId, index, ids) {
      return variantId && ids.indexOf(variantId) === index;
    });

    if ((!giftIds.length && module.getAttribute('data-gift-unavailable') !== 'true') || !threshold) return null;

    return {
      module: module,
      threshold: threshold,
      campaign: module.getAttribute('data-campaign') || 'sale-gift',
      tier: module.getAttribute('data-gift-tier') || '1',
      giftIds: giftIds,
      productGiftIds: productGiftIds
    };
  }

  function getGiftConfigs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-alunir-sale-gift]'))
      .map(getGiftConfig)
      .filter(Boolean);
  }

  function fetchCart() {
    return fetch(theme.routes.cart, {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function itemVariantId(item) {
    return Number(item.variant_id || item.id);
  }

  function isGiftItem(item) {
    var properties = item.properties || {};
    return properties._alunir_sale_gift === 'true' || properties._alunir_midsommar_gift === 'true';
  }

  function giftLines(cart, config) {
    return (cart.items || []).filter(function (item) {
      if (!isGiftItem(item)) return false;
      var properties = item.properties || {};
      var itemTier = String(properties._alunir_gift_tier || '');
      if (itemTier) return itemTier === String(config.tier);
      return config.productGiftIds.indexOf(itemVariantId(item)) !== -1;
    });
  }

  function eligibleCartTotal(cart, config) {
    return (cart.items || []).reduce(function (total, item) {
      if (isGiftItem(item)) return total;
      return total + Number(item.final_line_price || 0);
    }, 0);
  }

  function setGiftBusy(isBusy, module) {
    var scope = module || document;
    scope.querySelectorAll('[data-alunir-sale-gift-select]').forEach(function (button) {
      var giftModule = getGiftModule(button);
      button.disabled = isBusy || Boolean(giftModule && giftModule.classList.contains('is-locked'));
      button.classList.toggle('is-loading', isBusy);
    });
  }

  function refreshDrawerAfterGiftChange(cart) {
    if (typeof refreshCart === 'function') {
      refreshCart(cart);
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    if (typeof updateFreeShipping === 'function') {
      updateFreeShipping(cart);
    }
  }

  function emitCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart }
    }));
  }

  function runSequential(items, callback) {
    return items.reduce(function (promise, item) {
      return promise.then(function () {
        return callback(item);
      });
    }, Promise.resolve());
  }

  function normalizeGiftCart(cart, config) {
    var gifts = giftLines(cart, config);
    var eligibleTotal = eligibleCartTotal(cart, config);
    var changes = [];
    var keptCurrentGift = false;

    if (!gifts.length) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    gifts.forEach(function (line) {
      var isCurrentGiftVariant = config.giftIds.indexOf(itemVariantId(line)) !== -1;

      if (!isCurrentGiftVariant || eligibleTotal < config.threshold) {
        changes.push({ id: line.key, quantity: 0 });
        return;
      }

      if (!keptCurrentGift) {
        keptCurrentGift = true;
        if (Number(line.quantity) !== 1) {
          changes.push({ id: line.key, quantity: 1 });
        }
        return;
      }

      changes.push({ id: line.key, quantity: 0 });
    });

    if (!changes.length) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    return runSequential(changes, function (change) {
      return postCart(theme.routes.cartChange, change);
    }).then(fetchCart).then(function (freshCart) {
      return { cart: freshCart, changed: true };
    });
  }

  function enforceGiftState() {
    if (isSyncingGift) return;

    var configs = getGiftConfigs();
    if (!configs.length) return;

    isSyncingGift = true;
    fetchCart()
      .then(function (cart) {
        var result = { cart: cart, changed: false };
        return configs.reduce(function (promise, config) {
          return promise.then(function (current) {
            return normalizeGiftCart(current.cart, config).then(function (next) {
              return { cart: next.cart, changed: current.changed || next.changed };
            });
          });
        }, Promise.resolve(result));
      })
      .then(function (result) {
        if (!result.changed) return;
        refreshDrawerAfterGiftChange(result.cart);
        emitCartUpdated(result.cart);
      })
      .catch(function (error) {
        console.error('Sale gift sync failed:', error);
      })
      .finally(function () {
        isSyncingGift = false;
      });
  }

  function normalizeGiftCartFromServer(config) {
    return fetchCart().then(function (cart) {
      return normalizeGiftCart(cart, config);
    });
  }

  function chooseGift(button) {
    var variantId = Number(button.getAttribute('data-alunir-sale-gift-select'));
    var config = getGiftConfig(getGiftModule(button));
    if (!config || config.giftIds.indexOf(variantId) === -1) return;

    setGiftBusy(true, config.module);
    isSyncingGift = true;

    fetchCart()
      .then(function (cart) {
        if (eligibleCartTotal(cart, config) < config.threshold) {
          throw new Error('Gift threshold is not reached.');
        }

        return runSequential(giftLines(cart, config), function (line) {
          return postCart(theme.routes.cartChange, {
            id: line.key,
            quantity: 0
          });
        });
      })
      .then(function () {
        return postCart(theme.routes.cartAdd, {
          id: variantId,
          quantity: 1,
          properties: {
            _alunir_sale_gift: 'true',
            _alunir_gift_campaign: config.campaign,
            _alunir_gift_tier: config.tier
          }
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        refreshDrawerAfterGiftChange(cart);
        emitCartUpdated(cart);
      })
      .catch(function (error) {
        console.error('Sale gift selection failed:', error);
      })
      .finally(function () {
        isSyncingGift = false;
        setGiftBusy(false, config.module);
      });
  }

  function removeGift(lineKey) {
    if (!lineKey) return;

    setGiftBusy(true);
    isSyncingGift = true;

    postCart(theme.routes.cartChange, {
      id: lineKey,
      quantity: 0
    })
      .then(fetchCart)
      .then(function (cart) {
        refreshDrawerAfterGiftChange(cart);
        emitCartUpdated(cart);
      })
      .catch(function (error) {
        console.error('Sale gift removal failed:', error);
      })
      .finally(function () {
        isSyncingGift = false;
        setGiftBusy(false);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-alunir-sale-gift-select]');
    if (!button) return;

    event.preventDefault();
    chooseGift(button);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-alunir-sale-gift-remove]');
    if (!button) return;

    event.preventDefault();
    removeGift(button.getAttribute('data-line-key'));
  });

  document.addEventListener('DOMContentLoaded', enforceGiftState);
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(enforceGiftState, 250);
  });
  document.addEventListener('cart:updated', enforceGiftState);
  document.addEventListener('cart:drawer:open', enforceGiftState);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.js-drawer-open-cart')) {
      setTimeout(enforceGiftState, 250);
    }
  });
})();
